export default __webpack_public_path__ + "static/media/5_2.abe09edb.png";